import type { InspectorCommand } from "../types";

export function createIframeProxy(target: Window) {
	return new Proxy(
		{},
		{
			get(_, prop: string) {
				return (payload?: any) => {
					const cmd: InspectorCommand = { type: prop as any, ...(payload || {}) };
					target.postMessage(cmd, "*");
				};
			},
		},
	) as Record<InspectorCommand["type"], (p?: any) => void>;
}
